import { render, staticRenderFns } from "./StockOrderReceiving.vue?vue&type=template&id=2a516874"
import script from "./StockOrderReceiving.vue?vue&type=script&lang=ts"
export * from "./StockOrderReceiving.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports